/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../common";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const canvasRemoteLookupSchema = z.any();

export const canvasRemoteLookupIdSchema = common.objectId;

export const canvasRemoteLookupItemSchema = z.object({
  id: common.objectId,
  name: z.string().nullable(),
  is_archived: z.boolean(),
  is_draft: z.boolean(),
  territory_ids: z.array(common.objectId),
});

export const canvasRemoteLookupFiltersSchema = z.object({
  include_archived: z.boolean().nullable().nullable().optional(),
  territory_ids: z.array(common.objectId).nullable().nullable().optional(),
});

export const canvasRemoteLookupValidators = {
  id: canvasRemoteLookupIdSchema,
  item: canvasRemoteLookupItemSchema,
  filters: canvasRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: f2d2c99e526c5412736ffdf85ac389c1 */
